const getDateIntervall = (startDate, endDate) => {
    const dayIntervall = {}
    const startDateClone = startDate.clone()

    for(let currentDate = startDateClone; currentDate.isSameOrBefore(endDate); currentDate.add(1,'days')) {
        dayIntervall[currentDate.toISOString()] = [] // clone???
    }

    return dayIntervall
}

export default getDateIntervall